export function UncheckedIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_4226_37212)">
        <circle cx="9.99976" cy="9.99976" r="9" stroke="#98A2B3" stroke-width="1.67" />
      </g>
      <defs>
        <clipPath id="clip0_4226_37212">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export const displayName = "UncheckedIcon";
